import { h, render } from 'preact';
import { Provider } from 'react-redux';
import store from 'common/store/store';
import translator from 'common/i18n';
import { getVideoDuration } from 'common/helpers/videos';
import PaginationControls from 'common/components/PaginationControls';
import VideoPlayCta from 'common/components/videos/video-play-cta';
import VideoMetaData from 'common/components/videos/video-meta-data';

const PAGE_SIZE = 4;
export default class VideoRailContainer {
    constructor( container ) {
        this.container = container;
        const listRef = this.container.querySelector( '.js-list-ref' );
        const numEntries = parseInt(this.container.dataset.numEntries);
        this.cards = [ ...container.querySelectorAll( '.js-card-info' ) ];
        this.railItems = [ ...container.querySelectorAll( '.js-rail-item' ) ];

        this.cards.forEach( ( item, index ) => {
            const { videoId, title, url, duration, episodeNumber, series } = item.dataset;
            const progress = localStorage.getItem(`video-progress-${videoId}`);
            const seriesName = series ? translator.lookup('label.channel.series-number', { number: series }) : null; 
            const episodesLabel = episodeNumber ? translator.lookup('label.channel.episode-number', { number: episodeNumber }) : null;
            const progressBars = [ ...this.railItems[ index ].querySelectorAll( '.js-progress-bar' ) ];

            if ( progress ) {
                progressBars.forEach( progressBar => {
                    progressBar.style.width = `${progress}%`;
                    progressBar.parentElement.style.display = 'block';
                } );
            }

            render( (
                <Provider store={store}>
                    <VideoPlayCta
                        className='no-background video-rail-card'
                        progress={progress}
                        videoTitle={title}
                        onClick={() => location.href = url} />

                    <VideoMetaData
                        className='no-background video-rail-card'
                        duration={translator.lookup('label.channel.min', { minutes: getVideoDuration(duration) })}
                        series={seriesName}
                        episodes={episodesLabel}
                        watchProgress={0}
                        videoId={videoId}
                    />
                </Provider>
            ), item)
        });

        render( (
            <Provider store={store}>
                <PaginationControls 
                    listRef={listRef} 
                    slides={this.railItems} 
                    numEntries={numEntries} 
                    pageSize={PAGE_SIZE} 
                    hasAdder={false} 
                />
            </Provider>
        ), this.container)
    }

    // Called when the widget is removed from the page
    destroy() {
        render( null, this.container );
    }
}